import { cdnOrigin } from './environments';
import { lang } from './page';
import { request } from './request';

const english = 'en';

export async function getLangSet(uri = '', llang = lang) {
  const result = [];
  const languages = [llang, english];

  try {
    const results = await Promise.all(
      languages.map(async (i) => {
        const url = new URL(uri);

        url.searchParams.set('lang', i);

        const res = await request(url.href);
        const data = await res.json();

        return res.ok && Array.isArray(data.data) ? data.data : [];
      }),
    );

    result.push(results[0]);
    result.push(results[1]);
  } catch (err) {
    result.push([]);
    result.push([]);
  }

  return result;
}
